import { render, staticRenderFns } from "./AllLeavesTable.vue?vue&type=template&id=cb2f478e&"
import script from "./AllLeavesTable.vue?vue&type=script&lang=js&"
export * from "./AllLeavesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports